import { phpRequest } from "./phpRequest";
import { request } from "./request";
import { nubisGorequest } from "./nubisGorequest";

const nubis_v3 = "/nubis/v3";
const nubis_v1 = "/nubis_v1";
const platform_v3 = "/platform/v3";

export function deleteCompanyAPI(params) {
  return phpRequest.post("/company/delete", params);
}

export function checkIf2FA(ticket) {
  return request.post("/check_otp", { ticket });
}

export function sendEmailVerifyCode(params) {
  return request.post("/send_otp_code", params);
}

export function checkEmailVerifyCode(params) {
  return request.post("/verify_otp_code", params);
}

export function moveGroupAPI(params) {
  return phpRequest.post("/groups/move", params);
}

export async function createGroupApi(params) {
  const res = await phpRequest.post("groups/create", params);
  return res.group;
}

export function updateGroupApi(params) {
  return phpRequest.put("groups/update", params);
}

export function deleteGroupApi(params) {
  return phpRequest.delete("groups/delete", params);
}

export function updateUserInvisibleGroupApi(params) {
  return nubisGorequest.post(
    "/fec/nubis/v3/update_user_invisible_group",
    params
  );
}

export function getRoleListApi(params) {
  // return new Promise((resolve, reject) => {
  //   resolve({
  //     "roles": [
  //       {
  //         "id": "72731b8e-c35f-4d62-974d-6956e4a0e266",
  //         "name": "master"
  //       },
  //       {
  //         "id": "f1910bd6-6215-4b61-87c4-ef7b6a159be9",
  //         "name": "Administrator"
  //       },
  //       {
  //         "id": "c3fa247c-8787-11ee-bced-0242c0a8a803",
  //         "name": "Operator"
  //       },
  //       {
  //         "id": "c3fa2927-8787-11ee-bced-0242c0a8a803",
  //         "name": "Distributor"
  //       },
  //       {
  //         "id": "5e0f7933-52a5-46e9-9822-b32fc3ec020a",
  //         "name": "Manager"
  //       },
  //       {
  //         "id": "4ee086f4-354a-4672-bfbf-2dd0bcbfa717",
  //         "name": "Engineer"
  //       },
  //       {
  //         "id": "000d43ec-b371-4cba-86da-2e6ec6525fe8",
  //         "name": "Viewer"
  //       }
  //     ]
  //   })
  // })
  return nubisGorequest.post("/fec/nubis/v3/get_role_list", params);
}

export function getUserListApi(params, config) {
  return nubisGorequest.post("/fec/nubis/v3/get_user_list", params, config);
}

export function updateDeviceNameApi(params) {
  return phpRequest.put("/device/name", params);
}

export function updateDeviceDetailApi(params) {
  return nubisGorequest.post("/fec/nubis/v3/update_device_detail", params);
}

export function updateDeviceListFieldsApi(params) {
  return nubisGorequest.post("/fec/nubis/v3/update_device_list_fields", params);
}

export async function getDeviceListFieldsApi(params, config) {
  // const res = {
  //   "deviceListFields": "[{\"field\":\"online_offline_status\",\"show\":true,\"exportable\":true},{\"field\":\"serial_number\",\"show\":true,\"exportable\":true},{\"field\":\"device_name\",\"show\":true,\"exportable\":true},{\"field\":\"detail\",\"show\":true,\"exportable\":true},{\"field\":\"os_type\",\"show\":true,\"exportable\":true},{\"field\":\"groups\",\"show\":true,\"exportable\":true},{\"field\":\"tags\",\"show\":true,\"exportable\":true},{\"field\":\"power\",\"show\":true,\"exportable\":true},{\"field\":\"ora_version\",\"show\":true,\"exportable\":true},{\"field\":\"belong_to\",\"show\":true,\"exportable\":true},{\"field\":\"companies\",\"show\":true,\"exportable\":true},{\"field\":\"security\",\"show\":true,\"exportable\":true},{\"field\":\"nubis_version\",\"show\":true,\"exportable\":true},{\"field\":\"fecp_created_at\",\"show\":true,\"exportable\":true},{\"field\":\"fecp_activated_at\",\"show\":true,\"exportable\":true},{\"field\":\"latest_task.executed_at\",\"show\":true,\"exportable\":true},{\"field\":\"latest_task.status\",\"show\":true,\"exportable\":true},{\"field\":\"last_updated_at\",\"show\":true,\"exportable\":true},{\"field\":\"last_updated_status\",\"show\":true,\"exportable\":true}]"
  // }
  const res = await nubisGorequest.post(
    "/fec/nubis/v3/get_device_list_fields",
    params,
    config
  );
  return JSON.parse(res.deviceListFields);
}

export function importGroupsAPI(params) {
  return phpRequest.post("/groups/upload", params);
}

export function checkLoginPassword(params) {
  return phpRequest.post("/account/validate/password", params);
}

export function resetAlarmDeviceApi(params) {
  return request.post(nubis_v3 + "/reset_device", params);
}

export function getAlarmedPolicyListApi(params) {
  return request.post(nubis_v3 + "/alarmed_policy_option_list", params);
}

export function getDashboradSortResultApi(params) {
  return request.post(nubis_v3 + "/get_dashboard_module_order", params);
}

export function saveDashboradSortResultApi(params) {
  return request.post(nubis_v3 + "/update_dashboard_module_order", params);
}

export function statisticDevicesApi(params) {
  return phpRequest.get("/devices/filter", params);
}

export function bindDevicesTemplatesApi(params) {
  return phpRequest.post(
    "/alarm/deploy/assign-alarm-template-to-devices",
    params
  );
}

export function unbindDevicesTemplatesApi(params) {
  return phpRequest.delete("/alarm/deploy/unbind-devices-templates", params);
}

export function bindDevicesScheduleTemplatesApi(params) {
  return phpRequest.post("/schedule/deploy/templates", params);
}

export function unbindDevicesScheduleTemplatesApi(params) {
  return phpRequest.delete("/schedule/deploy/unbind", params);
}

export function renewGroupTokenApi(params) {
  return request.post(nubis_v3 + "/renew_group_token", params);
}

export function getGroupTokenApi(params) {
  return request.post(nubis_v3 + "/get_group_token", params);
}

export function getAlarmTemplatesApi(params) {
  return phpRequest.get("/alarm/template/datatable", params);
}

export function getScheduleTemplatesApi(params) {
  return phpRequest.get("/schedule/template/list", params);
}

export function getNamingList(params) {
  return request.post(nubis_v3 + "/naming_rule_list", params);
}

export function getMerchantConfigInfo(params) {
  return request.post(nubis_v3 + "/group_info", params);
}

export function getTriggeredDeviceList(params) {
  return request.post(nubis_v3 + "/triggered_device_list", params);
}

export function getFailedScheduleDeviceListApi(params) {
  return request.post(nubis_v3 + "/failed_scheduled_device_list", params);
}

export function getAccountInfo(params) {
  return phpRequest.get("/account/info", params);
}

export function removeDevice(params) {
  return request.post("/remove_device", params);
}

export function getTermList(param) {
  return request.post("/user_term_list", param);
}

export function confirmTerm(param) {
  return request.post("/confirm_term", param);
}

export const getCompanyCertInfoAPI = company_id => {
  return phpRequest.get("/company/cert_info", {
    company_id
  });
};

export const updateCompanyCertInfoAPI = company_id => {
  return phpRequest.post("/company-token/update", {
    company_id
  });
};

export function getPersonalizedLanguageConfig(params) {
  return request.post("personalize_config_info", params);
}

export function updatePersonalizedLanguageConfig(params) {
  return request.post("update_personalize_config", params);
}

export async function getQRCodeInfo(params) {
  return request.post("/company_api_info", params);
}
